import { render, staticRenderFns } from "./BulkActionModal.vue?vue&type=template&id=5916ac21"
import script from "./BulkActionModal.vue?vue&type=script&lang=ts"
export * from "./BulkActionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports